/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import store from './store'
import utils from './utils'
import vueAxios from 'vue-axios'
import axios from 'axios'
import moment from 'moment'
import 'moment/locale/zh-cn'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './theme/index.css'
//import ECharts from 'vue-echarts'

import htmlToPdf from '@/components/common/htmlToPdf'
import { message  } from '@/components/common/overrideMessage'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'

import Print from 'vue-print-nb'

Vue.config.productionTip = false

library.add(fas)
library.add(far)
library.add(fab)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)

//Vue.component('VueEcharts', ECharts)

Vue.use(Print)

Vue.use(vueAxios, axios)
Vue.use(utils)
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(htmlToPdf)

Vue.filter('dateFormat', function (input, pattern, lang) {
  if (lang === 'zh')
  	moment.locale('zh-cn')
  else
  	moment.locale(lang)
  if (pattern === 'from')
  	return moment(input).fromNow()
  else
  	return moment(input).format(pattern)
})

Vue.filter('roundNum', function(value) {
  return value.toFixed(2)
})

router.beforeEach((to, from, next) => {
  let allowBack = true
  if (to.meta.allowBack !== undefined) {
    allowBack = to.meta.allowBack
  }
  if (!allowBack) {
    history.pushState(null, null, location.href)
  }    
  store.dispatch('updateAppSetting', {
    allowBack: allowBack
  })
  if (to.path === '/login') {
    next();
  } else {
    let token = localStorage.getItem('token')
    //console.log(token)
    if (token === null || token === '' || token === 'undefined') {
      next('/login')
      next();
    } else {
      next();
    }
  }
})
Vue.prototype.$message = message
Vue.prototype.APP_CODE = '94182b0abf2f927a2977e558ecdb5539'
Vue.prototype.VERSION = '1.3.37'
Vue.prototype.IMG_URL = ''
Vue.prototype.SYSTEM_URL = ''

//dev
//Vue.prototype.BASE_URL = 'http://192.168.10.25:8080'
//Vue.prototype.API_PREFIX = 'http://192.168.10.25:8080/api/'

//dev
Vue.prototype.BASE_URL = 'http://192.168.1.12:8080'
Vue.prototype.API_PREFIX = 'http://192.168.1.12:8080/api/'

//dev1
//Vue.prototype.BASE_URL = 'http://172.24.167.120:8080'
//Vue.prototype.API_PREFIX = 'http://172.24.167.120:8080/api/'

//dev1
//Vue.prototype.BASE_URL = 'http://192.168.31.34:8080'
//Vue.prototype.API_PREFIX = 'http://192.168.31.34:8080/api/'


//prod
Vue.prototype.BASE_URL = 'http://business.kingfisherchina.com'
Vue.prototype.API_PREFIX = 'http://business.kingfisherchina.com/api/'

//Vue.prototype.BASE_URL = 'http://61.169.0.171:8888'
//Vue.prototype.API_PREFIX = 'http://61.169.0.171:8888/api/'

//Vue.prototype.BASE_URL = 'http://192.168.1.211:8888'
//Vue.prototype.API_PREFIX = 'http://192.168.1.211:8888/api/'


Vue.prototype.STATIC_URL = ''

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')